import { Typography } from '../primitives/index.js'
import cn from 'classnames'
import type { FC } from 'react'
import { Hotkey } from './hotkey.js'
import { makeLabel } from './make-label.js'
import type { Shortcut } from './shortcut.js'
import styles from './shortcut-box.module.css'

interface ShortcutBoxProps {
  className?: string
  shortcut: Shortcut
  showDescription?: boolean
}

const ShortcutBox: FC<ShortcutBoxProps> = props => {
  const { className, shortcut, showDescription = true } = props
  if (!shortcut) {
    return null
  }
  const { description } = shortcut
  return (
    <div className={cn(styles.container, className)}>
      <Hotkey>{makeLabel(shortcut.hotkey)}</Hotkey>
      {showDescription && (
        <Typography variant="subtitle1" className={styles.description}>
          {description}
        </Typography>
      )}
    </div>
  )
}

export default ShortcutBox
